import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaWifi, FaEye, FaHome, FaSyringe, FaFemale, FaAmbulance, FaArrowRight, FaUsers } from 'react-icons/fa';
import { getHomeTodayCount, getImmunizationTodayCount, getReferralTodayCount } from '../services/authService';
import Loader from '../components/Loader'; // Adjust path
const Dashboard = () => {
     const [loading, setLoading] = useState(true);
    const [homeTotal, setHomeTotal] = useState([]);
    const [immunizationTotal, setImmunizationTotal] = useState([]);
    const [referralTotal, setReferralTotal] = useState([]);

    const navigate = useNavigate();
    

    const homeVisitClick = () => {
      navigate('/home-visits'); // Change the route as needed
    }; 
    const ImmunizationClick = () => {
      navigate('/immunization'); // Change the route as needed
    }; 
    const ANCClick = () => {
      navigate('/anc'); // Change the route as needed
    }; 
     
    const referralClick = () => {
      navigate('/referrals'); // Change the route as needed
    }; 

    useEffect(() => {
      const fetchDashboardStats = async () => {
        try {
          const [homeRes, immunizationRes, referralRes] = await Promise.all([
            getHomeTodayCount(),
            getImmunizationTodayCount(),
            getReferralTodayCount(),
          ]);
    
          if (homeRes.status) {
            setHomeTotal(homeRes.data);
          }
    
          if (immunizationRes.status) {
            setImmunizationTotal(immunizationRes.data);
          }
    
          if (referralRes.status) {
            setReferralTotal(referralRes.data);
          } 
    
        } catch (error) {
          console.error('Error fetching dashboard stats:', error);
        } finally {
          setLoading(false);
        }
      };
    
      fetchDashboardStats();
    }, []);

    if (loading) return <Loader />;
    
  return ( 
    <>
      {/* Page Title */}
      <h1 className="page-title">Dashboard</h1>
      <p className="page-subtitle">Welcome back! Here's what's happening in your area.</p>



      {/* Quick Actions */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Quick Actions</div>
        </div>
        <div className="card-body">
          <div className="quick-actions">
            <div className="action-card" onClick={homeVisitClick}>
              <div className="action-icon" style={{ backgroundColor: 'var(--primary-light)', color: 'var(--primary)' }}>
                <FaHome />
              </div>
              <div className="action-text" >Home Visit</div>
            </div>
            <div className="action-card" onClick={ImmunizationClick}>
              <div className="action-icon" style={{ backgroundColor: 'var(--secondary-light)', color: 'var(--secondary)' }}>
                <FaSyringe />
              </div>
              <div className="action-text" >Immunization</div>
            </div>
            <div className="action-card" onClick={ANCClick}>
              <div className="action-icon" style={{ backgroundColor: 'var(--purple-light)', color: 'var(--purple)' }}>
                <FaFemale />
              </div>
              <div className="action-text">ANC</div>
            </div>
            <div className="action-card" onClick={referralClick}>
              <div className="action-icon" style={{ backgroundColor: 'var(--error-light)', color: 'var(--error)' }}>
                <FaAmbulance />
              </div>
              <div className="action-text">Referral</div>
            </div>
          </div>
        </div>
      </div>

      {/* Today's Tasks */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Today's Tasks</div>
          <a href="#" className="see-all">
            See All
            <FaArrowRight />
          </a>
        </div>
        <div className="card-body">
          <div className="tasks-grid">
            <div className="task-card">
              <div className="task-icon" style={{ backgroundColor: 'var(--primary)' }}>
                <FaHome />
              </div>
              <div className="task-content">
                <div className="task-title">Home Visits</div>
                <div className="task-count">{homeTotal}</div>
              </div>
            </div>
            <div className="task-card">
              <div className="task-icon" style={{ backgroundColor: 'var(--secondary)' }}>
                <FaSyringe />
              </div>
              <div className="task-content">
                <div className="task-title">Immunizations</div>
                <div className="task-count">{immunizationTotal}</div>
              </div>
            </div>
            <div className="task-card">
              <div className="task-icon" style={{ backgroundColor: 'var(--warning)' }}>
                <FaFemale />
              </div>
              <div className="task-content">
                <div className="task-title">ANC</div>
                <div className="task-count">2</div>
              </div>
            </div>
            <div className="task-card">
              <div className="task-icon" style={{ backgroundColor: 'var(--error)' }}>
                <FaAmbulance />
              </div>
              <div className="task-content">
                <div className="task-title">Referrals</div>
                <div className="task-count">{referralTotal}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Two Column Layout */}
      <div className="two-column">
        {/* Left Column */}
        <div>
          {/* Performance Chart */}
          <div className="chart-container">
            <div className="chart-header">
              <div className="chart-title">Monthly Performance</div>
              <a href="#" className="see-all">
                View Reports
                <FaArrowRight />
              </a>
            </div>
            <div className="chart-placeholder">
              <span>[Performance chart would be displayed here]</span>
            </div>
          </div>

          {/* Recent Activities */}
          <div className="card">
            <div className="card-header">
              <div className="card-title">Recent Activities</div>
              <a href="#" className="see-all">
                See All
                <FaArrowRight />
              </a>
            </div>
            <div className="activity-list">
              <div className="activity-item">
                <div className="activity-avatar" style={{ backgroundColor: 'var(--primary-light)', color: 'var(--primary)' }}>
                  <FaHome />
                </div>
                <div className="activity-content">
                  <div className="activity-header">
                    <div className="activity-title">Home visit completed</div>
                    <div className="activity-time">2h ago</div>
                  </div>
                  <div className="activity-description">Routine health checkup for Radha Devi</div>
                  <div className="activity-tags">
                    <span className="activity-tag">Radha Devi</span>
                    <span className="activity-tag">Rampur</span>
                  </div>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-avatar" style={{ backgroundColor: 'var(--secondary-light)', color: 'var(--secondary)' }}>
                  <FaSyringe />
                </div>
                <div className="activity-content">
                  <div className="activity-header">
                    <div className="activity-title">Immunization administered</div>
                    <div className="activity-time">4h ago</div>
                  </div>
                  <div className="activity-description">DPT booster dose for Anjali Kumar</div>
                  <div className="activity-tags">
                    <span className="activity-tag">Anjali Kumar</span>
                    <span className="activity-tag">Rampur</span>
                  </div>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-avatar" style={{ backgroundColor: 'var(--error-light)', color: 'var(--error)' }}>
                  <FaAmbulance />
                </div>
                <div className="activity-content">
                  <div className="activity-header">
                    <div className="activity-title">Referral created</div>
                    <div className="activity-time">Yesterday</div>
                  </div>
                  <div className="activity-description">Referred Ram Prasad to PHC for blood pressure check</div>
                  <div className="activity-tags">
                    <span className="activity-tag">Ram Prasad</span>
                    <span className="activity-tag">Rampur</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div>
          {/* Due Today */}
          <div className="card">
            <div className="card-header">
              <div className="card-title">Due Today</div>
              <a href="#" className="see-all">
                View All
                <FaArrowRight />
              </a>
            </div>
            <div className="due-list">
              <div className="due-item">
                <div className="due-avatar" style={{ backgroundColor: 'var(--secondary-light)', color: 'var(--secondary)' }}>
                  <FaSyringe />
                </div>
                <div className="due-info">
                  <div className="due-name">Rahul Kumar</div>
                  <div className="due-task">Immunization - Measles</div>
                  <div className="due-date">Due today</div>
                </div>
                <div className="due-action">
                  <FaArrowRight />
                </div>
              </div>
              <div className="due-item">
                <div className="due-avatar" style={{ backgroundColor: 'var(--purple-light)', color: 'var(--purple)' }}>
                  <FaFemale />
                </div>
                <div className="due-info">
                  <div className="due-name">Sita Devi</div>
                  <div className="due-task">ANC 3rd Visit</div>
                  <div className="due-date">Due today</div>
                </div>
                <div className="due-action">
                  <FaArrowRight />
                </div>
              </div>
              <div className="due-item">
                <div className="due-avatar" style={{ backgroundColor: 'var(--primary-light)', color: 'var(--primary)' }}>
                  <FaUsers />
                </div>
                <div className="due-info">
                  <div className="due-name">Ram Prasad</div>
                  <div className="due-task">Follow-up Visit</div>
                  <div className="due-date">Due today</div>
                </div>
                <div className="due-action">
                  <FaArrowRight />
                </div>
              </div>
            </div>
          </div>

          {/* Monthly Summary */}
          <div className="card">
            <div className="card-header">
              <div className="card-title">Monthly Summary</div>
              <a href="#" className="see-all">
                View Reports
                <FaArrowRight />
              </a>
            </div>
            <div className="card-body">
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon" style={{ backgroundColor: 'var(--primary-light)', color: 'var(--primary)' }}>
                    <FaUsers />
                  </div>
                  <div className="stat-content">
                    <div className="stat-title">Beneficiaries</div>
                    <div className="stat-value">127</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon" style={{ backgroundColor: 'var(--secondary-light)', color: 'var(--secondary)' }}>
                    <FaHome />
                  </div>
                  <div className="stat-content">
                    <div className="stat-title">Home Visits</div>
                    <div className="stat-value">45</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon" style={{ backgroundColor: 'var(--error-light)', color: 'var(--error)' }}>
                    <FaAmbulance />
                  </div>
                  <div className="stat-content">
                    <div className="stat-title">Referrals</div>
                    <div className="stat-value">10</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon" style={{ backgroundColor: 'var(--warning-light)', color: 'var(--warning)' }}>
                    <FaSyringe />
                  </div>
                  <div className="stat-content">
                    <div className="stat-title">Immunizations</div>
                    <div className="stat-value">32</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
  );
};

export default Dashboard;
